<template>
<div class="max-w-xl w-full h-64 rounded-xl overflow-hidden shadow-2xl bg-white flex flex-col justify-center">
    <div class="px-8 py-6 w-full text-center">
      <div class="font-bold text-2xl mb-4 text-gray-800">Today Sales</div>
      <p class="text-gray-900 text-3xl font-semibold tracking-wide">
        $2000
      </p>
    </div>
  </div>
</template>
<script>
import api from '../../../utils/axios';
import { ref } from 'vue';
    export default {
        name: 'DailySalesTotalCard',
        data() {
            return {
                sales: ref(),
            }
        },
        methods: {
           async getOrderSalesData() {
                const response = await api.get('/report/dailysalesreport');
                console.log('OrderCard: 25');
                console.log(response.data[6].sales_total)
                this.sales = response.data[6].sales_total;
                //this.sales = response.data;
            }
        },
        mounted() {
        console.log('組件已掛載，開始獲取資料...');
        this.getOrderSalesData(); // 自動執行
    }
    }
</script>